import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationData } from "../components/NotificationCard/types";

interface NotificationsState {
  notifications: NotificationData[];
  count: number
}

const initialState: NotificationsState = {
  notifications: [],
  count: null
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction<NotificationData[]>) {
      state.notifications = action.payload;
    },
    setNotificationCount(state, action: PayloadAction<number>) {
      state.count = action.payload;
    },
    markAsRead(state, action: PayloadAction<string[]>) {
      state.notifications = state.notifications.map((notification) =>
        action.payload.includes(notification.id)
          ? { ...notification, isRead: true }
          : notification
      );
    },
  },
});

export const { setNotifications, setNotificationCount, markAsRead } = notificationsSlice.actions;
export default notificationsSlice.reducer;
